module.exports = "https://cdn.realtymogul.com/static/media/icon_quality.e75ff4db.svg";